// Keep the Amada Sheet Report PDF with each cut sheet it made, so jobq-api can read where every piece sits
// (POST /cut_sheets/{id}/amada_pdf; the laser kiosk's sheet map). Never throws: a sheet whose map can't be
// read is still imported, the result says why.
import config from "../../config";
import { apiErrorMessage } from "../../utils/apiError";

// {PDF part no.: part_id} for the program's rows the import matched to a JobQ part.
export function partMapFor(prog, edit) {
  const out = {};
  (prog?.parts || []).forEach((p, i) => {
    const pe = edit?.parts?.[i];
    if (!pe || pe.removed || !pe.part_id || !p.product_id) return;
    out[p.product_id] = pe.part_id;
  });
  return out;
}

export async function uploadSheetMaps(file, uploads, createdBy) {
  const results = [];
  for (const u of uploads) {
    try {
      const fd = new FormData();
      fd.append("file", file);
      if (u.pages && u.pages.length) fd.append("pages", u.pages.join(","));
      fd.append("source", "import");
      if (u.partMap && Object.keys(u.partMap).length) fd.append("part_map", JSON.stringify(u.partMap));
      if (createdBy) fd.append("created_by_name", createdBy);
      const res = await fetch(`${config.API_BASE_URL}/cut_sheets/${u.cutSheetId}/amada_pdf`, { method: "POST", body: fd });
      if (!res.ok) {
        results.push({ ...u, ok: false, message: await apiErrorMessage(res, `Not saved (${res.status})`) });
        continue;
      }
      const body = await res.json();
      results.push({ ...u, ok: true, pieces: body.piece_count, problems: body.problems || [],
                     colour: body.colour !== false });
    } catch (e) {
      results.push({ ...u, ok: false, message: "No answer from JobQ." });
    }
  }
  return results;
}

export function mapsSummary(results) {
  if (!results || !results.length) return null;
  const ok = results.filter((r) => r.ok).length;
  const grey = results.filter((r) => r.ok && r.colour === false).length;
  return `Sheet maps for the laser screen: ${ok} of ${results.length} saved`
    + (grey ? ` (${grey} can't be coloured: the PDF couldn't be read cleanly)` : "") + ".";
}
